const CUSTOMER_SUPPORT_WORKING_TIMES = {
  END_HOUR: 20,
  START_HOUR: 8,
}

export const directContactTelephoneDialogIsCustomerSupportAvailable =
  (): boolean => {
    const currentHour = new Date(Date.now()).getHours()

    return (
      currentHour >= CUSTOMER_SUPPORT_WORKING_TIMES.START_HOUR &&
      currentHour < CUSTOMER_SUPPORT_WORKING_TIMES.END_HOUR
    )
  }
